import React, { useEffect, useState } from "react";
import { NavigationalButtons } from "./CreateAudioWizard";
import { Form, Formik } from "formik";
import useAxios from "axios-hooks";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import DropDown from "../../../../Forms/DropDown";
import { Spinner } from "@fluentui/react";

const CategoryStep = ({ audioId, nextOnClick, prevOnClick, audio }) => {
    const [selectedTags, setSelectedTags] = useState(null);
    const [{ loading: audioTagsLoading, data: audioTags }] = useAxios(
        {
            url: `resources/audio/${audioId}/tags`,
            method: "get",
        })

    const [{ loading: submitting }, postForm] = useAxios(
        {
            url: `resources/audio/${audioId}/categorization`,
            method: "put",
        },
        { manual: true }
    );

    const [{ data: categories, loading: loadingCategories }] = useAxios('courses/con-categories');
    const [{ data: tags, loading: loadingTags }] = useAxios('courses/con-tags');

    const focuses = ["Basics", "Stress", "Growth"]

    useEffect(() => {
        audioTags && setSelectedTags(audioTags);
    }, [audioTags]);

    if (!selectedTags || loadingCategories || loadingTags)
        return <Spinner className="absolute-center" label="Loading..." />;

    return (
        <div>
            <Formik
                initialValues={{ conCategoryId: audio.conCategoryId, conTagIds: selectedTags, teaserTag_CONTagID: audio.teaserTagId, focus: audio.focus }}
                onSubmit={async (values) => {
                    const result = await postForm({ data: values });

                    if (!result.isAxiosError) {
                        nextOnClick();
                    }
                }}
            >
                <Form>
                    <ChoiceGroup label="Category" name="conCategoryId" options={categories && categories.map(category => ({ key: category.id, text: category.name }))} required />
                    <ChoiceGroup label="Focus" name="focus" options={focuses && focuses.map(focus => ({ key: focus, text: focus }))}  required />
                    <DropDown multiSelect label="Tags" name="conTagIds" options={tags && tags.map(tag => ({ key: tag.id, text: tag.name }))}
                        handleChangeMultiSelect={(event, option, keys) => {
                            setSelectedTags(keys);
                        }}
                    />
                    <ChoiceGroup label="Teaser Tag" name="teaserTag_CONTagID" options={tags && tags.filter(t => selectedTags.includes(t.id)).map(t => ({ key: t.id, text: t.name }))} required />
                    <NavigationalButtons
                        loading={submitting}
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default CategoryStep;
